import React from "react"
import {
  InitializePaymentSessionOutputType,
  useEditOrderPaymentInitializeMutation,
} from "../../../../api/backend/backend-api"
import { editOrderTypPagePath } from "../../../../root/routing/urls"
import CustomAlert from "../../../../ui/atoms/Alert"
import CustomButton from "../../../../ui/atoms/Button"
import Typography from "../../../../ui/atoms/Typography"
import { formatMoney } from "../../../../utils/money"
import PaymentMethodsBox from "../../../checkout/components/payment/PaymentMethodsBox"
import { redirectToPayment } from "../../../checkout/services/paymentService"
import { CompletedOrder } from "../../types"

interface Props {
  order: CompletedOrder
}

const EditOrderPendingPayment = ({ order }: Props) => {
  const [providerId, setProviderId] = React.useState("stripe")
  const [loading, setLoading] = React.useState(false)
  const [
    initializePayment,
    { error: paymentInitError },
  ] = useEditOrderPaymentInitializeMutation()

  const handlePayment = async () => {
    try {
      setLoading(true)
      const result = await initializePayment({
        variables: {
          input: {
            orderId: order.id,
            providerId,
            cancelUrl: window.location.href,
            paymentCompletedBaseUrl: `${
              window.location.origin
            }${editOrderTypPagePath()}`,
          },
        },
      })
      if (!result.data?.editOrderPaymentInitialize) {
        setLoading(false)
        throw new Error("Empty response")
      }
      redirectToPayment(
        result.data
          .editOrderPaymentInitialize as InitializePaymentSessionOutputType
      )
    } catch (e) {
      console.error("Error creating payment attempt", e)
      setLoading(false)
    }
  }
  return (
    <div>
      <Typography
        variant="subtitle2"
        weight="normal"
      >{`Pagamento in sospeso di ${formatMoney({
        amount: order.editOrderPendingPayment?.amount as number,
        currency: "eur",
      })}`}</Typography>
      <div>
        <PaymentMethodsBox
          enabledPaymentProviders={[]}
          providerId={providerId}
          onProviderIdChange={setProviderId}
        />
        <CustomButton onClick={handlePayment} loading={loading}>
          Paga
        </CustomButton>
        <CustomAlert
          severity="error"
          show={!!paymentInitError}
          className="mt-2"
        >
          Ops, si è verificato un errore
        </CustomAlert>
      </div>
    </div>
  )
}

export default EditOrderPendingPayment
